import React from "react";
import { renderToString } from "react-dom/server";
import { PinSvg } from "./PinSvg";

export type VenueMapPinType = {
  type: "venue";
}

export const getVenueMapPin = () => {
  const element = document.createElement("div");
  element.innerHTML = renderToString(<VenuePin />);
  return element;
}

export const VenuePin = () => {
  return <div className="google-map-pin-wrapper">
    <PinSvg width={27} height={43} empty fillColor="var(--map-venue-blue)" />
  </div>
}